export default __webpack_public_path__ + "static/media/review.c8e50075.png";